"use strict";

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Storage = void 0;

require("isomorphic-unfetch");

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/storage");

var _browserOrNode = require("browser-or-node");

var _uuid = require("uuid");

var _constants = require("../constants");

var _responseBuilder = require("./responseBuilder");

var _retryFetch = require("./retryFetch");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FIREBASE_MJS_ID = 'FIREBASE_MJS_ID';
var ARWEAVE_FOLDER = 'arweave';
var headers = {
  apiKey: 'api-key'
};

var Storage = /*#__PURE__*/function () {
  function Storage() {
    var storageConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Storage);

    _defineProperty(this, "firebase", void 0);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "apiKey", void 0);

    _defineProperty(this, "constants", void 0);

    this.constants = storageConfig.constants || {};
    this.apiKey = storageConfig.apiKey || 'anonymous';

    var mintbaseJSFirebase = _app["default"].apps.find(function (_ref) {
      var name = _ref.name;
      return name === FIREBASE_MJS_ID;
    });

    this.firebase = mintbaseJSFirebase !== null && mintbaseJSFirebase !== void 0 ? mintbaseJSFirebase : _app["default"].initializeApp(this.constants.CLOUD_STORAGE_CONFIG || _constants.CLOUD_STORAGE_CONFIG, FIREBASE_MJS_ID);
    this.storage = this.firebase.storage();
  }
  /**
   * Uploads metadata to Arweave via a cloud function
   * @param metadata metadata object
   * @returns arweave content identifier
   */


  _createClass(Storage, [{
    key: "uploadMetadata",
    value: function () {
      var _uploadMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(metadata) {
        var request, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _retryFetch.retryFetch)("".concat(_constants.CLOUD_URI, "/arweave/metadata/"), {
                  method: 'POST',
                  body: JSON.stringify(metadata),
                  headers: _defineProperty({}, headers.apiKey, this.apiKey || 'anonymous')
                });

              case 3:
                request = _context.sent;
                _context.next = 6;
                return request.json();

              case 6:
                data = _context.sent;
                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.uploadMetadata
                }));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function uploadMetadata(_x) {
        return _uploadMetadata.apply(this, arguments);
      }

      return uploadMetadata;
    }()
    /**
     * Upload file to Arweave via a cloud function
     * @param file the file to upload
     * @returns retunrns an object containing the arweave content identifier and the content type.
     */

  }, {
    key: "uploadToArweave",
    value: function () {
      var _uploadToArweave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
        var buffer, contentType, _yield$this$uploadClo, fileName, error, request, _yield$request$json, id, _contentType, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_browserOrNode.isNode) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Node environment does not yet supports uploads.'
                }));

              case 2:
                _context2.next = 4;
                return file.arrayBuffer();

              case 4:
                buffer = _context2.sent;
                contentType = file.type;
                _context2.prev = 6;
                _context2.next = 9;
                return this.uploadCloud(buffer, contentType);

              case 9:
                _yield$this$uploadClo = _context2.sent;
                fileName = _yield$this$uploadClo.data;
                error = _yield$this$uploadClo.error;

                if (!error) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: error
                }));

              case 14:
                _context2.prev = 14;
                _context2.next = 17;
                return (0, _retryFetch.retryFetch)("".concat(_constants.CLOUD_URI, "/arweave/file/").concat(fileName), {
                  headers: _defineProperty({}, headers.apiKey, this.apiKey || 'anonymous')
                });

              case 17:
                request = _context2.sent;
                _context2.next = 20;
                return request.json();

              case 20:
                _yield$request$json = _context2.sent;
                id = _yield$request$json.id;
                _contentType = _yield$request$json.contentType;
                data = {
                  id: id,
                  contentType: _contentType
                };

                if (!(!id || !_contentType)) {
                  _context2.next = 26;
                  break;
                }

                throw new Error(_constants.ERROR_MESSAGES.decentralizedStorageFailed);

              case 26:
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 29:
                _context2.prev = 29;
                _context2.t0 = _context2["catch"](14);
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.decentralizedStorageFailed
                }));

              case 32:
                _context2.next = 37;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2["catch"](6);
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _context2.t1.message
                }));

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 34], [14, 29]]);
      }));

      function uploadToArweave(_x2) {
        return _uploadToArweave.apply(this, arguments);
      }

      return uploadToArweave;
    }()
    /**
     * Uploads raw binary data to the cloud. This method is useful because
     * we can trigger an arweave upload via an http request with the returned file name.
     * @param buffer the raw binary data of the file to upload
     * @param contentType the content type
     * @returns the filename
     */

  }, {
    key: "uploadCloud",
    value: function () {
      var _uploadCloud = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(buffer, contentType) {
        var fileName;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_browserOrNode.isNode) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Node environment does not yet supports uploads.'
                }));

              case 2:
                _context3.prev = 2;
                fileName = (0, _uuid.v4)();

                if (this.storage) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Storage is not initialized'
                }));

              case 6:
                _context3.next = 8;
                return this.storage.ref("".concat(ARWEAVE_FOLDER, "/").concat(fileName)).put(buffer, {
                  contentType: contentType
                });

              case 8:
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: fileName
                }));

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](2);
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.uploadCloud
                }));

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 11]]);
      }));

      function uploadCloud(_x3, _x4) {
        return _uploadCloud.apply(this, arguments);
      }

      return uploadCloud;
    }()
  }]);

  return Storage;
}();

exports.Storage = Storage;